/**
 * PHARMAKON — the ONE exact code resolver's vocabulary (refonte WP-11 / WP-12, `GET /codes/resolve`;
 * design/ux/04 §4.2), browser twin of the server CONFIG `apps/server/src/config/code-barre-lot.config.js`
 * (`TYPE_RESOLUTION_CODE`, `RAISON_CODE_INCONNU`, `CODE_RESOLUTION.CANAL_DEFAUT`). The counters read
 * the answer kinds (cross-module XWP-25) and the offline gate answers the same shape from the synced
 * snapshot. A twin, not an import (the API image is built from apps/server alone): the server test
 * `src/__tests__/resolution-code.parity.test.js` fails on any drift — change a value there first.
 */

/** What a code designates in the caller's pharmacy. */
export const TYPE_RESOLUTION_CODE = Object.freeze({
  LOT: "LOT",
  PRODUIT: "PRODUIT",
  AMBIGU: "AMBIGU",
  INCONNU: "INCONNU",
});

/** Why a code resolved to INCONNU. */
export const RAISON_CODE_INCONNU = Object.freeze({
  CLE_INVALIDE: "CLE_INVALIDE",
  INTROUVABLE: "INTROUVABLE",
});

/** The channel whose product gates apply when the caller names none (the counter, the strictest). */
export const CANAL_RESOLUTION_DEFAUT = "VENTE_LIBRE";

/**
 * Cross-module X XWP-95 / XWP-96 (XO-23) — what a box scan of one product answers at the counter
 * (`produits[].selection_lot` of `GET /codes/resolve`, server `config/disponibilite.config.js`
 * SELECTION_LOT_COMPTOIR): the lot taken automatically, the caissier's choice (the Propriétaire's
 * setting on and more than one sellable lot visible), or the rupture (nothing sellable → the secours
 * form). `null` on a gated product.
 */
export const SELECTION_LOT_COMPTOIR = Object.freeze({ AUTO: "AUTO", CHOIX: "CHOIX", RUPTURE: "RUPTURE" });
